<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <CidadaoDocumentos
            :data-atual="form.cidadao.dataAtual"
            :form="form.cidadao.documentos"
            :model="model.cidadao"
        />

        <rkm-area
            type="section"
            title="Conselho profissional"
        >
            <rkm-row>
                <rkm-col :cols="tipoRegistroOutro ? 2 : 6">
                    <rkm-form-select
                        :options="form.documentos.conselhoProfissional.tiposRegistro"
                        label="Tipo"
                        text-field="descricao"
                        v-model="model.documentos.conselhoProfissional.registroTipoId"
                        value-field="id"
                        :validations="validations.registroTipo"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col
                    v-if="tipoRegistroOutro"
                    cols="4"
                >
                    <rkm-form-input
                        :validations="validations.registroTipoOutro"
                        label="Outro"
                        v-model="model.documentos.conselhoProfissional.registroTipoOutro"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.registroNumero"
                        label="Número"
                        v-model="model.documentos.conselhoProfissional.registroNumero"
                        :disabled="!model.documentos.conselhoProfissional.registroTipoId"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        :options="form.documentos.conselhoProfissional.estados"
                        :validations="validations.registroEstado"
                        label="UF"
                        text-field="uf"
                        v-model="model.documentos.conselhoProfissional.registroEstadoId"
                        :disabled="!model.documentos.conselhoProfissional.registroNumero"
                        value-field="id"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>
// Components.
import CidadaoDocumentos from '@/components/cadastro/cidadao/Documentos'

// Enums.
import tipoRegistro from '@/enums/cadastro/usuario/tipoRegistro'

export default {
    components: { CidadaoDocumentos },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        enums: { tipoRegistro },
    }),
    computed: {
        validations() {

            return {
                registroTipo: {},
                registroNumero: {
                    required: !!this.model.documentos.conselhoProfissional.registroTipoId,
                    max: 25
                },
                registroEstado: {
                    required: !!this.model.documentos.conselhoProfissional.registroNumero
                },
                registroTipoOutro: {
                    required: this.tipoRegistroOutro,
                    max: 50,
                }
            }
        },
        tipoRegistroOutro() {

            return this.model.documentos.conselhoProfissional.registroTipoId === this.enums.tipoRegistro.OUTRO
        }
    },
    watch: {
        'model.documentos.conselhoProfissional.registroTipoId': function (id) {

            if (!id) {

                this.model.documentos.conselhoProfissional.registroNumero = ''

                return
            }

            if (id !== this.enums.tipoRegistro.OUTRO) {

                this.model.documentos.conselhoProfissional.registroTipoOutro = ''
            }
        },
        'model.documentos.conselhoProfissional.registroNumero': function (numero) {

            if (!numero) {

                this.model.documentos.conselhoProfissional.registroEstadoId = null
            }
        }
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
    }
}
</script>